"use strict";

import angular from "angular";

import { Validations } from "../../../imports/validations";
import template from "./module-toolbar.component.html";
import "./module-toolbar.component.scss";

/**
 * @component nu-module-toolbar
 * O <nu-module-toolbar> è um componente que é usado para mostrar uma toolbar com um ícone e um tooltip
 */

class ModuleToolbarCtrl {
    constructor($stateParams, $scope, $state) {
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.$state = $state;
    }
    $onInit() {
        this.items = this.flagPermissionFilter(this.items);
    }
    _hasFlag = (item) => {
        if (!item.flag) return item;
        let flag = item.flag.split(".");
        let hideCompanyUser = item.hideCompanyUser;
        if (
            flag.length > 1 &&
            Validations.getPermission(flag[0], flag[1]) &&
            !hideCompanyUser
        )
            return item;
        if (
            flag.length === 1 &&
            Validations.hasFeatureFlag(flag) &&
            !hideCompanyUser
        )
            return item;
    };
    flagPermissionFilter = (items) => {
        items = items.map((item) => {
            return item.filter(this._hasFlag);
        });
        let item = items.filter((e) => e.length);
        return item;
    };
}

ModuleToolbarCtrl.$inject = ["$stateParams", "$scope", "$state"];

const name = "nuModuleToolbar";
const def = {
    bindings: {
        items: "="
    },
    controller: ModuleToolbarCtrl,
    controllerAs: "moduleToolbar",
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
